export const productNameFieldInformation = (
  <div>
    <div className="font-bold">Nombre del producto.</div>
    <div>Principalmente usado por bodega para identificar el producto.</div>
  </div>
);

export const matchingStringFieldInformation = (
  <div>
    <div className="font-bold">Matching String.</div>
    <div>
      Usado para buscar el producto en la base de datos al momento de agendar
      por <span className="italic">WhatsApp</span>. Este campo debe ser lo más
      parecido a la forma que se agendara.
    </div>
    <div className="flex gap-2 flex-col mt-2">
      <div className="outline-dashed outline-gray-300 outline-1 rounded-md p-2">
        <span className="font-bold">Ejemplo:</span>
        <span className="italic">
          Para el saco de 20 kg Easy Clean, el matching string sería{" "}
          <span className="font-bold">Easy Clean 20kg</span>.
        </span>
      </div>
    </div>
  </div>
);

export const quantityFieldInformation = (
  <div>
    <div className="font-bold">Formato / Cantidad.</div>
    <div>Numero usado para identificar la cantidad de productos.</div>

    <div className="flex gap-2 flex-col mt-2">
      <div className="outline-dashed outline-gray-300 outline-1 rounded-md p-2">
        <span className="font-bold">Ejemplo 1:</span>
        <span className="italic">
          Para el saco de 20 kg Easy Clean, el formato sería{" "}
          <span className="font-bold">20</span>.
        </span>
      </div>
      <div className="outline-dashed outline-gray-300 outline-1 rounded-md p-2">
        <span className="font-bold">Ejemplo 2:</span>
        <span className="italic">
          Para el saco de 10 kg Fit Formula, el formato sería{" "}
          <span className="font-bold">10</span>.
        </span>
      </div>
      <div className="outline-dashed outline-gray-300 outline-1 rounded-md p-2">
        <span className="font-bold">Ejemplo 3:</span>
        <span className="italic">
          Para un producto que se vende por unidad (snack cremosos, galletas,
          bebederos de agua, etc), el formato sería{" "}
          <span className="font-bold">1</span>.
        </span>
      </div>
    </div>
  </div>
);

export const discountByQuantityFieldInformation = (
  <div>
    <div className="font-bold">Tabla de Precios.</div>
    <div>
      Si el producto tiene descuento por más de una unidad, se debe activar esta
      opción.
    </div>
    <ul className="list-disc list-inside">
      <li>
        <span className="italic">Activado: </span>
        <span className="">Se usa la tabla de precios por defecto.</span>
      </li>
      <li>
        <span className="italic">Desactivado: </span>
        <span className="">
          Se usa el precio de <span className="font-bold">una (1)</span> unidad
          y se multiplica por la cantidad.
        </span>
      </li>
    </ul>
  </div>
);

export const includesGiftFieldInformation = (
  <div>
    <div className="font-bold">¿Incluye regalo?</div>
    <div>Si el producto incluye regalo, se debe activar esta opción.</div>
  </div>
);

export const includeGiftMinQtFieldInformation = (
  <div>
    <div className="font-bold">
      Mínima cantidad de unidades para incluir regalo.
    </div>
    <div>
      Si un pedido lleva esta cantidad o más unidades de este producto, se
      añadirá regalo.
    </div>
  </div>
);

export const includeGiftMaxQtFieldInformation = (
  <div>
    <div className="font-bold">
      Máxima cantidad de unidades para incluir regalo.
    </div>
    <div>
      Si un pedido lleva esta cantidad o menos unidades de este producto, se
      añadirá regalo.
    </div>
  </div>
);

export const weightFieldInformation = (
  <div>
    <div className="font-bold">Peso.</div>
    <div>Peso del producto en kilogramos.</div>
    <div className="text-red-500 font-bold">NO CAMBIAR VALOR POR DEFECTO.</div>
  </div>
);

export const isWholesalerFieldInformation = (
  <div>
    <div className="font-bold">¿Es mayorista?</div>
    <div>Si el producto es mayorista, se debe activar esta opción.</div>
    <div className="text-red-500 font-bold">NO CAMBIAR VALOR POR DEFECTO.</div>
  </div>
);

export const wholesalerQtyFieldInformation = (
  <div>
    <div className="font-bold">Cantidad de mayorista.</div>
    <div>Cantidad de productos que se debe comprar para ser mayorista.</div>
    <div className="text-red-500 font-bold">NO CAMBIAR VALOR POR DEFECTO.</div>
  </div>
);

export const countsAsMangaFieldInformation = (
  <div>
    <div className="font-bold">¿Cuenta como manga?</div>
    <div>Si el producto cuenta como manga, se debe activar esta opción.</div>
  </div>
);
